// extracted by mini-css-extract-plugin
export default {"titleWrapper":"styles_titleWrapper__WBoxE","hide":"styles_hide__jAkCB","contentContainer":"styles_contentContainer__fqa85","greyLine":"styles_greyLine__len0P"};